import {
  ADD_FUNDS_REQUESTED,
  FUNDS_ADDED,
  FUNDS_FAILED_TO_ADD,
  FUNDS_TRANSFER_REQUESTED,
  FUNDS_TRANSFERRED,
  FUNDS_FAILED_TO_TRANSFER,
  TRANSFER_HISTORY_REQUESTED,
  TRANSFER_HISTORY_LOADED,
  TRANSFER_HISTORY_FAILED_TO_LOAD,
  LIST_OF_ACCOUNTS_REQUESTED,
  LIST_OF_ACCOUNTS_LOADED,
  LIST_OF_ACCOUNTS_FAILED_TO_LOAD
} from './constants';

import { DABBL_PUBLISHER_ID } from '../../../config';

import callAPI from '../callAPI';

export function loadListOfAccounts(page=0,size=1000){
  return callAPI({
    path:`/portal/v1/account/list?size=${size}&page=${page}`,
    begin:{
      type:LIST_OF_ACCOUNTS_REQUESTED,
      payload:() => ({})
    },
    success:{
      type:LIST_OF_ACCOUNTS_LOADED,
      payload:(res) => res.data
    },
    failure:{
      type:LIST_OF_ACCOUNTS_FAILED_TO_LOAD
    }
  });
}

export function loadAccountHistory(id){
  return callAPI({
    path:`/portal/v1/account/history?accountId=${id}`,
    begin:{
      type:TRANSFER_HISTORY_REQUESTED,
      payload:() => ({})
    },
    success:{
      type:TRANSFER_HISTORY_LOADED,
      payload:(res) => res.data
    },
    failure:{
      type:TRANSFER_HISTORY_FAILED_TO_LOAD
    }
  });
}

export function addFundsToCampaignFromAgency(agencyId,paymentMethodId,campaignId,amount,io){
  return callAPI({
    method:'POST',
    path:'/portal/v1/account/transfer',
    body:{
      fromAccountId:agencyId,
      toAccountId:campaignId,
      paymentMethodId:paymentMethodId,
      amount:parseFloat(amount),
      io: io
    },
    begin:{
      type:FUNDS_TRANSFER_REQUESTED,
      payload:(res) => ({})
    },
    success:{
      type:FUNDS_TRANSFERRED,
      payload:(res) => res.data
    },
    failure:{
      type:FUNDS_FAILED_TO_TRANSFER
    }
  });
}


export function addFundsToCampaignDirectly(paymentMethodId,campaignId,amount,io=""){
  return callAPI({
    method:'POST',
    path:'/portal/v1/account/transfer',
    body:{
      fromAccountId:DABBL_PUBLISHER_ID,
      toAccountId:campaignId,
      paymentMethodId:paymentMethodId,
      amount:parseFloat(amount),
      io:io
    },
    begin:{
      type:FUNDS_TRANSFER_REQUESTED,
      payload:(res) => ({})
    },
    success:{
      type:FUNDS_TRANSFERRED,
      payload:(res) => res.data
    },
    failure:{
      type:FUNDS_FAILED_TO_TRANSFER
    }
  });
}

export function removeFundsFromCampaignToAgency(agencyId,paymentMethodId,campaignId,amount){
  return callAPI({
    method:'POST',
    path:'/portal/v1/account/transfer',
    body:{
      fromAccountId:campaignId,
      toAccountId:agencyId,
      paymentMethodId:paymentMethodId,
      amount:parseFloat(amount)
    },
    begin:{
      type:FUNDS_TRANSFER_REQUESTED,
      payload:(res) => ({})
    },
    success:{
      type:FUNDS_TRANSFERRED,
      payload:(res) => res.data
    },
    failure:{
      type:FUNDS_FAILED_TO_TRANSFER
    }
  });
}


export function removeFundsFromCampaignDirectly(agencyId,paymentMethodId,campaignId,amount){
  return callAPI({
    method:'POST',
    path:'/portal/v1/account/transfer',
    body:{
      fromAccountId:campaignId,
      toAccountId:DABBL_PUBLISHER_ID,
      paymentMethodId:paymentMethodId,
      amount:parseFloat(amount)
    },
    begin:{
      type:FUNDS_TRANSFER_REQUESTED,
      payload:(res) => ({})
    },
    success:{
      type:FUNDS_TRANSFERRED,
      payload:(res) => res.data
    },
    failure:{
      type:FUNDS_FAILED_TO_TRANSFER
    }
  });
}

export function addFundsToAgency(agencyId,paymentMethodId,amount){
  return callAPI({
    method:'POST',
    path:'/portal/v1/account/transfer',
    body:{
      fromAccountId:DABBL_PUBLISHER_ID,
      toAccountId:agencyId,
      paymentMethodId:paymentMethodId,
      amount:parseFloat(amount),
      io:""
    },
    begin:{
      type:FUNDS_TRANSFER_REQUESTED,
      payload:(res) => ({})
    },
    success:{
      type:FUNDS_TRANSFERRED,
      payload:(res) => res.data
    },
    failure:{
      type:FUNDS_FAILED_TO_TRANSFER
    }
  });
}

export function createIO(agencyId,paymentMethodId,amount,io="", documents){
  return callAPI({
    method:'POST',
    path:'/portal/v1/account/transfer',
    body:{
      fromAccountId:DABBL_PUBLISHER_ID,
      toAccountId:agencyId,
      paymentMethodId:paymentMethodId,
      amount:parseFloat(amount),
      io:io,
      documents: documents
    },
    begin:{
      type:FUNDS_TRANSFER_REQUESTED,
      payload:(res) => ({})
    },
    success:{
      type:FUNDS_TRANSFERRED,
      payload:(res) => res.data
    },
    failure:{
      type:FUNDS_FAILED_TO_TRANSFER
    }
  });
}

export function updateIODocuments(accountLedgerId, documents){
  return callAPI({
    method:'PATCH',
    path:`/portal/v1/account/io/${accountLedgerId}`,
    body: documents,
    begin:{
      type:FUNDS_TRANSFER_REQUESTED,
      payload:(res) => ({})
    },
    success:{
      type:FUNDS_TRANSFERRED,
      payload:(res) => res.data
    },
    failure:{
      type:FUNDS_FAILED_TO_TRANSFER
    }
  });
}



// WEBPACK FOOTER //
// ./src/shared/redux/accounting/actions.js